import axios from "axios"

const cartActions = {
  onQuantityAdjust(event) {
    $(document).on('click', '.qty__adjust', function(event) {
      event.preventDefault()
      const qtyInput = $(this).closest('.cartItem__quantity').find('.cart__qty-input');
      let step = 1;
      let currentQty = parseInt(qtyInput.val());

      if($(this).hasClass('qty__adjust--decrease')) {
        step = -1;
      }

      qtyInput.val(currentQty + step).trigger('change');
    });
  },

  onQuantityChange() {
    let self = this

    $(document).on('change', '.cart__qty-input', function(event) {
      const cartItem = $(this).closest('.cartItem')
      let quantity = $(this).val()
      const previousQuantity = parseInt($(this).attr('data-value'));
      const rootBundleId = cartItem.attr('data-rootBundleId')
      const maxValue = $(this).attr('max') ? parseInt($(this).attr('max')) : false;

      if (maxValue !== false) {
        if (maxValue <= 0 && previousQuantity < quantity) {
          $(this).val(previousQuantity);
          quantity = previousQuantity;
          return false;
        }

        if (quantity > previousQuantity + maxValue) {
          $(this).val(previousQuantity + maxValue);
          quantity = previousQuantity + maxValue;
        }
      }

      let data = {}

      if(rootBundleId) {
        $('.cartItem[data-bundleId="child-' + rootBundleId + '"]').each(function(){
          let lineKey = $(this).attr('data-line-key')
          var itemQuantity = parseInt($(this).attr('data-itemQuantity'))
          data[lineKey] = itemQuantity * quantity
        })
      } else {
        let lineKey = cartItem.attr('data-line-key')
        data[lineKey] = quantity
      }

      self.updateCart(data)
    });
  },

  onRemoveItem() {
    let self = this

    $(document).on('click', '.cartItem__remove', function(event) {
      event.preventDefault()
      const cartItem = $(this).closest('.cartItem')
      const rootBundleId = cartItem.attr('data-rootBundleId')
      let data = {}

      if(rootBundleId) {
        $('.cartItem[data-bundleId="child-' + rootBundleId + '"]').each(function(){
          let lineKey = $(this).attr('data-line-key')
          data[lineKey] = 0
        })
      } else {
        let lineKey = cartItem.attr('data-line-key')
        data[lineKey] = 0
      }

      self.updateCart(data)
    });
  },

  updateCart(data) {
    axios.post('/cart/update.js', {
      updates: data
    }).then(res => {
      axios.get('/cart')
      .then(res => {
        var rawData = $(res.data).find('#cartTemplate').html()
        var encodedData = encodeURIComponent(rawData)
        $('#cartTemplate').html(decodeURIComponent(encodedData))
      }).catch(error => {
        console.log(error)
      })

    }).catch(error => {
      console.log(error)
    })
  },

  init() {
    this.onQuantityAdjust()
    this.onQuantityChange()
    this.onRemoveItem()
  }
}

export default cartActions
